import Typography from "@mui/material/Typography";
import { SxProps, Theme } from "@mui/material/styles";

type KeyFrameMessageProps = {
  message: string;
  height?: string;
  sx?: SxProps<Theme>;
};

const mergeSx = (
  base: SxProps<Theme>,
  additional?: SxProps<Theme>
): SxProps<Theme> => {
  if (!additional) {
    return base;
  }

  if (Array.isArray(additional)) {
    return [base, ...additional] as SxProps<Theme>;
  }

  return [base, additional] as SxProps<Theme>;
};

const baseMessageSx: SxProps<Theme> = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textWrap: "wrap",
};

const KeyFrameMessage: React.FC<KeyFrameMessageProps> = ({
  message,
  height = "100%",
  sx,
}): JSX.Element => {
  return (
    <Typography
      component="div"
      variant="body2Bold"
      textAlign="center"
      color="otherTextTertiary.main"
      sx={mergeSx({ ...baseMessageSx, height }, sx)}
    >
      {message}
    </Typography>
  );
};

export default KeyFrameMessage;
